var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-modal',{attrs:{"title":_vm.title,"width":_vm.width,"position":_vm.position,"resize":"","destroy-on-close":""},on:{"show":_vm.modalOpen,"hide":_vm.modalClose},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }